import React from "react";
import logo from "../../Assert/Logo/linkly.png";

const Logo = () => {
  return (
    <div>
      <img
        src={logo}
        alt="Brand Logo"
        className="w-36 h-36 mx-auto transition-transform duration-300 transform hover:scale-105"
      />
    </div>
  );
};

export default Logo;
